/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'picto-profil-situation-2': {
    width: 41,
    height: 43,
    viewBox: '0 0 41 43',
    data: '<path pid="0" class="st0" d="M38.6 42.4c-.8 0-1.5-.7-1.5-1.5 0-9.4-7.7-17.1-17.1-17.1-9.4 0-17.1 7.7-17.1 17.1 0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5c0-11 9-20 20-20s20 9 20 20c.2.8-.5 1.5-1.3 1.5"/><path pid="1" class="st0" d="M20 23.2c-6.4 0-11.6-5.2-11.6-11.6S13.6 0 20 0c6.4 0 11.6 5.2 11.6 11.6S26.4 23.2 20 23.2m0-20.3c-4.8 0-8.7 3.9-8.7 8.7s3.9 8.7 8.7 8.7c4.8 0 8.7-3.9 8.7-8.7S24.8 2.9 20 2.9"/>'
  }
})
